<template>
  <status-badge
    v-if="displayMode === 'label'"
    color="red lighten-1"
    class="white--text"
    :title="trans('booking.canceledBooking')"
    v-bind="$attrs"
  >{{ trans('booking.canceled') }}</status-badge>
  <v-icon
    v-else-if="displayMode === 'icon'"
    color="red lighten-1"
    :title="trans('booking.canceledBooking')"
    v-bind="$attrs"
  >mdi-book-cancel</v-icon>
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import StatusBadge from './StatusBadge';

export default {
  name: 'BookingStatusCanceled',
  components: {StatusBadge},
  mixins: [
    LocaleUtils
  ],
  props: {
    displayMode: {
      default () {
        return 'label';
      }
    }
  }
}
</script>
